import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import RoleRegister from "./roleRegister";

class Roles extends Component {
  state = {
    breadcrumbItems: [
      { title: "TravelQuail", link: "/" },
      { title: "Roles", link: "/roles" },
    ],
  };
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Roles"
              breadcrumbItems={this.state.breadcrumbItems}
            />

            <RoleRegister />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default Roles;
